var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HDSProgressIndicator } from "@here/hds-react-components/ProgressIndicator";
import translations from "../../translations/resources/en-GB.json";
export var ConfirmBody = function () { return (_jsxs("div", __assign({ style: {
        textAlign: "center",
        verticalAlign: "middle",
        overflow: "hidden",
    } }, { children: [_jsx(HDSProgressIndicator, { variant: "indeterminate", indicatorType: "circular", size: "large", color: "accent", style: { position: "relative", left: "48%" } }), _jsx("p", { children: translations.data["venonboard.attributeQAReport.reportGeneration"] })] }))); };
